export default "__VITE_ASSET__DGhkmosw__"